import React from 'react';
import SearchableSelect from '../ui/SearchableSelect';
import FilterPopover, { FilterSelectSpec } from '../ui/FilterPopover';

interface Props {
  category: string;
  onCategoryChange: (v: string) => void;
  status: string;
  onStatusChange: (v: string) => void;
  /** Distinct values found on the project's events (nothing is hard-coded). */
  categories: string[];
  statuses: string[];
}

const opts = (all: string, values: string[]) => [{ value: '', label: all }, ...values.map(v => ({ value: v, label: v }))];

/**
 * Category and Status behind the one Filters popover, as on the other list
 * bars. A bar left with a single choice keeps that plain select.
 */
export const EventsFilters: React.FC<Props> = ({ category, onCategoryChange, status, onStatusChange, categories, statuses }) => {
  const selects: FilterSelectSpec[] = [];
  if (categories.length > 0) {
    selects.push({ key: 'category', label: 'Category', options: opts('All Categories', categories), value: category, defaultValue: '', onChange: onCategoryChange });
  }
  if (statuses.length > 0) {
    selects.push({ key: 'status', label: 'Status', options: opts('All Statuses', statuses), value: status, defaultValue: '', onChange: onStatusChange });
  }
  if (selects.length === 0) return null;
  if (selects.length === 1) {
    const s = selects[0];
    return (
      <div className="header-filter-group">
        <SearchableSelect className="header-filter-select" value={s.value} onChange={s.onChange} options={s.options} />
      </div>
    );
  }
  return <FilterPopover selects={selects} />;
};

export default EventsFilters;
